import { Component } from '@angular/core';
import { AbstractWidget } from '../abstracts/abstract-widget';

@Component({
  selector: 'gtd-widgets-info-layout',
  templateUrl: './info-widget.component.html',
})
export class InfoWidgetComponent extends AbstractWidget {}
